// The employment title is free text and users often put the workplace inside it
// ("Physical Therapist at Physical Therapy Central"). `company_name` is the structured,
// linked Company record — keep it visible, but avoid stuttering: join with ", " when the
// title already carries an "at" phrase, and drop the company when the title already names
// it. Prod-sampled (30k pitched-source employments): ~1/3 of "at"-titled rows repeat the
// company in a slightly different form ("Partner at James Moore & Co" + "James Moore &
// Co."), so on that path the leading company word (min 4 chars) also counts as a dupe.
export const entitySubtitle = (entity) => {
  const title = entity.title || '';
  const company = entity.company_name || '';
  if (!title) return company;
  if (!company) return title;
  const lowerTitle = title.toLowerCase();
  if (lowerTitle.includes(company.toLowerCase())) return title;
  if (/ at /i.test(title)) {
    const firstWord = company.split(/\s+/)[0] || '';
    if (firstWord.length >= 4 && lowerTitle.includes(firstWord.toLowerCase())) return title;
    return `${title}, ${company}`;
  }
  return `${title} at ${company}`;
};

export default { entitySubtitle };
